import React, { useEffect, useState } from "react";
import BarekamInput from "../../../../components/input";
import { Product } from "../../../../shared/models/order/product.model";
import { useAppSelector } from "../../../../../redux/store";
import { Message, MessageSections } from "../../../../components/message/message";
import BarekamText from "../../../../components/text";
import { VolumeContainer } from "../../../../calculate/styled";
import { getMessage } from "../../../../shared/helper-functions";
import { getVolumeMultiplier } from "../../../../calculate/calculate-functions";

export const ProductDimensions = ({ product, errors, handleChange, isReadonly }: ProductDimensionProps) => {

    const [volume, setVolume] = useState(0);

    const { messageCache, languageId } = useAppSelector(state => state.messagesReducer);

    useEffect(() => {
        setVolume((product.width || 0) * (product.height || 0) * (product.length || 0))
    }, [product.width, product.height, product.length])

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
            <VolumeContainer>
                <BarekamText variant={'m'} opaque>
                    <Message messageKey={'volume_multiplier'} sectionId={MessageSections.ORDERS} />:
                </BarekamText>

                <BarekamText variant={'m'}>
                    {getVolumeMultiplier(volume, 2).toFixed(2)}
                </BarekamText>
            </VolumeContainer>

            <div style={{ display: 'flex', gap: '1rem' }}>
                <BarekamInput value={product.length}
                    placeholder={getMessage('calculate_length', MessageSections.ORDERS, messageCache, languageId)}
                    customInputVariant={"standard"}
                    width={'100%'}
                    error={!!errors['length']}
                    isReadonly={isReadonly}
                    errorMessage={errors['length'] && getMessage(errors['length'], MessageSections.ORDERS, messageCache, languageId)}
                    onChange={(event) => handleChange(+event.target.value, 'length', product)} validNumber/>

                <BarekamInput value={product.width}
                    placeholder={getMessage('calculate_width', MessageSections.ORDERS, messageCache, languageId)}
                    customInputVariant={"standard"}
                    width={'100%'}
                    error={!!errors['width']}
                    isReadonly={isReadonly}
                    errorMessage={errors['width'] && getMessage(errors['width'], MessageSections.ORDERS, messageCache, languageId)}
                    onChange={(event) => handleChange(+event.target.value, 'width', product)} validNumber/>

                <BarekamInput value={product.height}
                    placeholder={getMessage('calculate_height', MessageSections.ORDERS, messageCache, languageId)}
                    customInputVariant={"standard"}
                    width={'100%'}
                    error={!!errors['height']}
                    isReadonly={isReadonly}
                    errorMessage={errors['height'] && getMessage(errors['height'], MessageSections.ORDERS, messageCache, languageId)}
                    onChange={(event) => handleChange(+event.target.value, 'height', product)} validNumber/>
            </div>
        </div>
    )
}

interface ProductDimensionProps {
    product: Product,
    errors: { [key: string]: string },
    isReadonly: boolean,
    handleChange: (value: any, fieldName: string, product: Product) => void,
}